import { render, staticRenderFns } from "./ItemAttribs.vue?vue&type=template&id=0a4c058b&scoped=true&"
import script from "./ItemAttribs.vue?vue&type=script&lang=js&"
export * from "./ItemAttribs.vue?vue&type=script&lang=js&"
import style0 from "./ItemAttribs.vue?vue&type=style&index=0&id=0a4c058b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c058b",
  null
  
)

export default component.exports